<template>
    <div class="modal-wrapper" :class="{'open': this.value.type !== ''}" @click="handleOutsideClick">
        <transition name="fade">
            <address-add-modal v-if="this.value.type === 'address-add'"
                               @close="close"
                               :data="this.value.data"
                               :header="this.value.header"></address-add-modal>
            <address-remove-modal v-if="this.value.type === 'address-remove'" @close="close" :data="this.value.data" :header="this.value.header"></address-remove-modal>
            <ip-address-add-modal v-if="this.value.type === 'ip-add'" @close="close" :data="this.value.data" :header="this.value.header"></ip-address-add-modal>
            <ip-address-remove-modal v-if="this.value.type === 'ip-address-remove'" @close="close" :data="this.value.data" :header="this.value.header"></ip-address-remove-modal>
            <user-add-modal v-if="this.value.type === 'user-add'" @close="close" :data="this.value.data" :header="this.value.header"></user-add-modal>
            <user-remove-modal v-if="this.value.type === 'user-remove'" @close="close" :data="this.value.data" :header="this.value.header"></user-remove-modal>
            <asset-share-modal v-if="this.value.type === 'asset-share'" @close="close" :data="this.value.data" :header="this.value.header"></asset-share-modal>
            <public-asset-share-modal v-if="this.value.type === 'public-asset-share'" @close="close" :data="this.value.data" :header="this.value.header"></public-asset-share-modal>
            <password-update-modal v-if="this.value.type === 'password-update'" @close="close" :data="this.value.data" :header="this.value.header"></password-update-modal>
            <order-update-modal v-if="this.value.type === 'order-update'"  @close="close" :data="this.value.data" :header="this.value.header"></order-update-modal>
        </transition>
    </div>
</template>

<script>
import UserAddModal from '@/views/Private/Components/Modal/UserAddModal'
import IpAddressAddModal from '@/views/Private/Components/Modal/IpAddressAddModal'
import IpAddressRemoveModal from '@/views/Private/Components/Modal/IpAddressRemoveModal'
import AddressAddModal from '@/views/Private/Components/Modal/AddressAddModal'
import AddressRemoveModal from '@/views/Private/Components/Modal/AddressRemoveModal'
import UserRemoveModal from '@/views/Private/Components/Modal/UserRemoveModal'
import AssetShareModal from '@/views/Private/Components/Modal/AssetShareModal'
import PublicAssetShareModal from '@/views/Private/Components/Modal/PublicAssetShareModal'
import PasswordUpdateModal from '@/views/Private/Components/Modal/PasswordUpdateModal'
import OrderUpdateModal from '@/views/Private/Components/Modal/OrderUpdateModal'

export default {
  name: 'RootModal',
  props: ['value'],
  components: {
    AddressAddModal,
    IpAddressAddModal,
    IpAddressRemoveModal,
    UserAddModal,
    UserRemoveModal,
    AssetShareModal,
    PublicAssetShareModal,
    PasswordUpdateModal,
    OrderUpdateModal,
    AddressRemoveModal
  },
  methods: {
    close () {
      this.value.header = false
      this.value.type = ''
      this.value.data = {}
      this.$emit('input', this.value)
    },
    handleOutsideClick (event) {
      // return if clicked on some of next elements
      if (['modal-box'].indexOf(event.target.className) > -1) {
        return
      }

      let element = document.getElementsByClassName('modal-box')
      element = element[0]
      if (
        element &&
        event.target !== element &&
        !element.contains(event.target)
      ) {
        this.close()
      }
    }
  }
}
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave {
        opacity: 0;
    }
</style>
